<template>
    <div class="final-page" id="final-page">
        <app-loading 
            v-if="is_loading"
        />
        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="$router.push('/survey')"
            @clickMenu="change_menu(context, true)"
        />

<!--        <app-player-editor-->
<!--            :key="videos_component_key"-->
<!--            :videos="videos"-->
<!--        />-->
      <new-player
          v-if="readyState"
          :videos="videos"
          @loadingComplete="is_loading = false"
          :key="videos_component_key"
          @changeKey="videos_component_key = `f${(~~(Math.random()*1e8)).toString(16)}`"
      />

        <app-music-view 
            v-show="false"
            :music="music"
            :audio="music.file"
            :id="music.id"
        />

        <div class="final-page__footer" id="add-video-page__footer">
            <div class="final-page__footer-row" style="padding: 10px 16px 8px 16px">
                <div class="final-page__footer-text">
                    Длительность
                </div>
                <div class="final-page__footer-duration">
                    {{duration}}
                </div>
            </div>
            <div class="final-page__footer-row" style="padding: 0px 16px 0px 16px">
                <div class="final-page__footer-text">
                    Стоимость
                </div>
                <div class="final-page__footer-price">
                    от {{price}} руб

                    <svg @click="final_click_info(context)" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.66272 9.72033C7.66272 9.36477 7.7205 9.05366 7.83605 8.78699C7.9605 8.51144 8.10717 8.28033 8.27605 8.09366C8.45383 7.90699 8.68494 7.68477 8.96939 7.42699C9.32494 7.11588 9.58717 6.84921 9.75605 6.62699C9.92494 6.39588 10.0094 6.12033 10.0094 5.80033C10.0094 5.36477 9.8405 5.0181 9.50272 4.76032C9.16494 4.49366 8.69828 4.36033 8.10272 4.36033C7.06272 4.36033 6.26717 4.71144 5.71605 5.41366L4.74272 4.72033C5.11605 4.24033 5.59161 3.87144 6.16939 3.61366C6.75605 3.35588 7.43161 3.22699 8.19605 3.22699C9.16494 3.22699 9.93383 3.44033 10.5027 3.86699C11.0716 4.28477 11.3561 4.86255 11.3561 5.60033C11.3561 5.96477 11.2938 6.28921 11.1694 6.57366C11.0538 6.84921 10.9116 7.08033 10.7427 7.26699C10.5738 7.45366 10.3472 7.67588 10.0627 7.93366C9.69828 8.26255 9.42717 8.55144 9.24939 8.80033C9.0805 9.04921 8.99605 9.35588 8.99605 9.72033H7.66272ZM8.34272 12.747C8.09383 12.747 7.88494 12.667 7.71605 12.507C7.55605 12.3381 7.47605 12.1337 7.47605 11.8937C7.47605 11.6537 7.55605 11.4537 7.71605 11.2937C7.88494 11.1248 8.09383 11.0403 8.34272 11.0403C8.59161 11.0403 8.79605 11.1248 8.95605 11.2937C9.11605 11.4537 9.19605 11.6537 9.19605 11.8937C9.19605 12.1337 9.11161 12.3381 8.94272 12.507C8.78272 12.667 8.58272 12.747 8.34272 12.747Z" fill="white"/>
                        <circle cx="8" cy="8" r="7.5" stroke="white"/>
                    </svg>
                </div>
            </div>
          <div class="final-page__footer-row" style="padding: 0px 16px 0px 16px">
            <div class="final-page__footer-text">
              {{ surveyName }}
            </div>
            <div class="final-page__footer-price">
              от {{surveyPrice}} руб

              <svg @click="final_click_info(context)" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.66272 9.72033C7.66272 9.36477 7.7205 9.05366 7.83605 8.78699C7.9605 8.51144 8.10717 8.28033 8.27605 8.09366C8.45383 7.90699 8.68494 7.68477 8.96939 7.42699C9.32494 7.11588 9.58717 6.84921 9.75605 6.62699C9.92494 6.39588 10.0094 6.12033 10.0094 5.80033C10.0094 5.36477 9.8405 5.0181 9.50272 4.76032C9.16494 4.49366 8.69828 4.36033 8.10272 4.36033C7.06272 4.36033 6.26717 4.71144 5.71605 5.41366L4.74272 4.72033C5.11605 4.24033 5.59161 3.87144 6.16939 3.61366C6.75605 3.35588 7.43161 3.22699 8.19605 3.22699C9.16494 3.22699 9.93383 3.44033 10.5027 3.86699C11.0716 4.28477 11.3561 4.86255 11.3561 5.60033C11.3561 5.96477 11.2938 6.28921 11.1694 6.57366C11.0538 6.84921 10.9116 7.08033 10.7427 7.26699C10.5738 7.45366 10.3472 7.67588 10.0627 7.93366C9.69828 8.26255 9.42717 8.55144 9.24939 8.80033C9.0805 9.04921 8.99605 9.35588 8.99605 9.72033H7.66272ZM8.34272 12.747C8.09383 12.747 7.88494 12.667 7.71605 12.507C7.55605 12.3381 7.47605 12.1337 7.47605 11.8937C7.47605 11.6537 7.55605 11.4537 7.71605 11.2937C7.88494 11.1248 8.09383 11.0403 8.34272 11.0403C8.59161 11.0403 8.79605 11.1248 8.95605 11.2937C9.11605 11.4537 9.19605 11.6537 9.19605 11.8937C9.19605 12.1337 9.11161 12.3381 8.94272 12.507C8.78272 12.667 8.58272 12.747 8.34272 12.747Z" fill="white"/>
                <circle cx="8" cy="8" r="7.5" stroke="white"/>
              </svg>
            </div>
          </div>
            <div class="final-page__button-wrapper">
                <div class="final-page__button" 
                    :class="{ 'final-page__button-active' : true}"
                    @click="$router.push('/calendar')"
                >
                    <div class="final-page__button-text"
                        :class="{'final-page__button-text-active' : true}"
                    >
                        Выбрать дату
                    </div>
                </div>
            </div>
            
        </div>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >
        
        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>

        <transition 
            name="default-fade" 
            appear
            mode="out-in"
        >
            <app-popup
                :text="popup.text"
                :growButton="popup.growButton"
                :moreText="popup.moreText"
                v-if="popup.value"
                @clickGrowButtonPopup="close_popup(context)"
            />
        </transition>
    </div>
</template>

<script>

    const AppLoading = () => import('@/components/loading.vue')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppPopup = () => import('@/components/popups/popup.vue')
    // const AppPlayerEditor = () => import('@/components/player-editor/player-editor.vue')
    const AppMusicView = () => import('@/components/music-view.vue')
    const NewPlayer = () => import('@/components/new-player')

    import final_created_hook from "@/views/final/modules/final_created_hook";
    import change_menu from "@/views/theme/modules/change_menu";
    import close_popup from "@/views/video_editor/modules/close_popup";
    import final_click_info from "@/views/final/modules/final_click_info";
    
    export default {
        async created() {
          await this.final_created_hook(this)
        },
        data() {
            return {
                context: this,
                readyState: false,
                is_loading: true,
                rendering: false,
                videos: [],
                overlay: false,
                videos_component_key: `f${(~~(Math.random()*1e8)).toString(16)}`,
                popup: {
                    value: false,
                    text: '',
                    growButton: false
                },
                menu: false
            }
        },
        components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            AppPopup,
            // AppPlayerEditor,
            NewPlayer,
            AppMusicView
        },
        computed: {
            loading() {
              console.log(this.rendering)
              console.log(this.videos.length)
              return !(this.rendering && this.videos.length)
            },
            duration() {
                let num = this.$store.getters['price/duration']
                let m = Math.trunc(num / 60)
                let s = ( num - (m * 60))
                return `${m} мин. ${s} сек.`
            },
            price() {
                return this.$store.getters['price/price']
            },
            entry() {
              return this.$store.getters['entry_video/entry']
            },
            main() {
              return this.$store.getters['main_videos/main']
            },
            ending() {
                return this.$store.getters['ending_video/ending']
            },
            music() {
                return this.$store.getters['music/music']
            },
            surveyPrice() {
              return this.$store.getters['survey_price/selectSurveyPrice']
            },
            surveyName() {
              return this.$store.getters['survey_price/selectSurveyName']
            }
        },
        methods: {
          final_created_hook,
          change_menu,
          close_popup,
          final_click_info
        }
    }
</script>

<style lang="less">
    .final-page {
        background-color: black;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
    }

    #final-page .header-component {
        z-index: 10;
    }

    .final-page__container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .final-page__logo {
        width: 54px;
        height: 54px;
        cursor: pointer;
    }

    .final-page__logo img {
        width: 100%;
        height: 100%;
    }

    .final-page__footer {
        width: 100%;
        z-index: 10;
        background-color: #2F1F4C;
        position: relative;
        min-height: 207px;
        bottom: 0px;
    }

    .final-page__footer-row {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .final-page__footer-text {
        color: #FFFFFF;
        opacity: 0.5;
        font-size: 15px;
        line-height: 20px;
        font-family: 'Roboto-Light';
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .final-page__footer-price {
        color: #FFFFFF;
        font-size: 22px;
        line-height: 28px;
        font-family: 'Montserrat-Bold';
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .final-page__footer-price svg {
        width: 23px;
        height: 23px;
        margin-left: 8px;
        cursor: pointer;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .final-page__footer-duration {
        color: #FFFFFF;
        font-size: 15px;
        line-height: 20px;
        font-family: 'Montserrat-Medium';
    }

    .final-page__button-wrapper {
        width: 100%;
        position: absolute;
        bottom: 16px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .final-page__button {
        height: 44px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        color: #31283D;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 12px;
        cursor: pointer;
        font-family: 'Montserrat-Medium';
    }

    .final-page__button-text {
        font-family: 'Montserrat-Medium';
        opacity: .5;
        color:  #FFFFFF;
        line-height: 12px;
        font-size: 16px;
    }

    .final-page__button-active {
        background: #FFFFFF;
    }

    .final-page__button-text-active {
        color: #31283D;
        opacity: 1;
    }

</style>